<template>
  <div class="zombieSource">
    <div class="tit_t">僵尸信源列表</div>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finished_text"
      @load="onLoad"
    >
      <div class="itemBox">
        <!-- <div
          class="listItem flex"
          :class="{ none: index === 0 }"
          v-for="(item, index) in itemBoxArr"
          :key="index"
        >
          <img :src="item.imgUrl" class="wx" alt="" />
          <div class="itemR">
            <div class="flex">
              <div class="t" :title="item.siteName">{{ item.siteName }}</div>
              <div class="time">
                未更新天数：<span>{{ item.days }}天</span>
              </div>
            </div>
            <div class="translate">{{ item.sourceId }}</div>
            <div class="updateTime">最后更新日期：{{ item.publishTime }}</div>
          </div>
        </div> -->
        <div
          class="listItem"
          :class="{ none: index === 0 }"
          v-for="(item, index) in itemBoxArr"
          :key="index"
        >
          <div class="tit flex-wrap-start">
            {{ item.siteName }}
          </div>
          <div class="translate">{{ item.sourceId }}</div>
          <div class="flex_between mt25">
            <div class="flex_center">
              <img :src="item.imgUrl" class="tb" alt="" />
              <div class="updateTime">最后更新日期：{{ item.publishTime }}</div>
            </div>
            <div class="time flex_center">
              未更新天数：<span>{{ item.days }}</span
              >天
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <template v-if="finished && itemBoxArr.length === 0">
      <div class="nodata-box">
        <p>暂无数据</p>
      </div>
    </template>
    <!-- <div class="nodata_box border_box" v-show="noData">无数据</div> -->
  </div>
</template>

<script>
let moment = require("moment");
import { List, Toast } from "vant";
import { getList, getCode } from "@/api/wmzombieSource";
export default {
  name: "zombieSource",
  components: {
    "van-list": List,
  },
  data() {
    return {
      loading: false,
      finished_text: "",
      noData: false,
      finished: false,
      total: 0,
      params: {
        pageSize: 10, // 每页条数
        pageNo: 0, //页码
      },
      itemBoxArr: [],
      siteTypeImgMap: {
        "01": require("@/assets/images/zombieSource/site_type_img_01.png"),
        "04": require("@/assets/images/zombieSource/site_type_img_04.png"),
        "06": require("@/assets/images/zombieSource/site_type_img_06.png"),
        11: require("@/assets/images/zombieSource/site_type_img_11.png"),
        12: require("@/assets/images/zombieSource/site_type_img_12.png"),
        13: require("@/assets/images/zombieSource/site_type_img_13.png"),
        14: require("@/assets/images/zombieSource/site_type_img_14.png"),
        15: require("@/assets/images/zombieSource/site_type_img_15.png"),
        16: require("@/assets/images/zombieSource/site_type_img_16.png"),
        17: require("@/assets/images/zombieSource/site_type_img_17.png"),
        18: require("@/assets/images/zombieSource/site_type_img_18.png"),
        19: require("@/assets/images/zombieSource/site_type_img_19.png"),
        20: require("@/assets/images/zombieSource/site_type_img_20.png"),
      },
      videoIcon: {
        "01": require("@/assets/images/zombieSource/video_icon01.png"),
        "02": require("@/assets/images/zombieSource/video_icon02.png"),
        "03": require("@/assets/images/zombieSource/video_icon03.png"),
        "04": require("@/assets/images/zombieSource/video_icon04.png"),
        "05": require("@/assets/images/zombieSource/video_icon05.png"),
        "06": require("@/assets/images/zombieSource/video_icon06.png"),
        "07": require("@/assets/images/zombieSource/video_icon07.png"),
        "08": require("@/assets/images/zombieSource/video_icon08.png"),
        "09": require("@/assets/images/zombieSource/video_icon09.png"),
        10: require("@/assets/images/zombieSource/video_icon10.png"),
      },
    };
  },
  created() {
    let pageUrl = this.$route.path;
    if (pageUrl === "/zombieSource") {
      // document.querySelector("link.linkico").href = "./wmlogo.ico";
      document.querySelector("link.linkico").href = "./wmico.ico";
    } else {
      document.querySelector("link.linkico").href = "./favicon.ico";
    }
  },
  mounted() {
    if (localStorage.getItem("wlgl-token") && localStorage.getItem("wlgl-openId")) {
      this.onLoad()
    } else if (
      !!localStorage.getItem("wlgl-token") == "" &&
      Object.keys(this.$route.query).length === 0
    ) {
      this.errmsg = 20016;
    } else {
      this.init();
    }
  },
  methods: {
    init() {
      if (Object.keys(this.$route.query).length) {
        const code = this.$route.query.code;
        const state = this.$route.query.state;
        this.queryCode(code, state);
      }
    },
    // 获取列表数据
    onLoad() {
      if (
        !!localStorage.getItem("wlgl-token") == "" &&
        Object.keys(this.$route.query).length === 0
      ) {
        this.errmsg = 20016;
        return false;
      }
      // 接口响应前，先显示加载中
      this.loading = true;
      this.finished_text = "";
      this.params.pageNo = this.params.pageNo + 1;
			this.params.openId = localStorage.getItem("wlgl-openId") || ''
      getList(this.params)
        .then((res) => {
          this.loading = false;
          console.log(res);
          if (res.data.code === 200) {
            let total = res.data.data.total;
            console.log(total);
            if (res.data.data.data && res.data.data.data.length > 0) {
              res.data.data.data.forEach((item) => {
                item.publishTime = item.publishTime
                  ? moment(item.publishTime).format("YYYY-MM-DD")
                  : "";
                if (item.siteTypeCode === "11") {
                  item.imgUrl = this.videoIcon[item.videoType];
                } else {
                  item.imgUrl = this.siteTypeImgMap[item.siteTypeCode];
                }
              });
              this.itemBoxArr = [...this.itemBoxArr, ...res.data.data.data];
              // if (this.itemBoxArr.length === 0) {
              //   this.noData = true;
              // }
              // if (this.itemBoxArr.length >= total) {
              //   this.finished = true;
              // }
              if (res.data.data.length < 10) {
                this.finished = true;
              }
            } else {
              this.noData = true;
              this.finished = true;
            }
            // if (this.itemBoxArr.length > 0 && this.itemBoxArr.length >= total && this.finished) {
            if (this.itemBoxArr.length > 0 && this.finished) {
              this.finished_text = "没有更多了";
            } else {
              this.finished_text = "";
            }
            // 加载状态结束
            this.loading = false;
          } else if (res.data.code === 20009) {
            this.loading = false;
            this.finished = true;
            this.finished_text = "";
            this.itemBoxArr = [];
            this.params = {
              pageSize: 10,
              pageNo: 0,
							openId: ''
            };
            // token 失效
            this.init();
          } else {
            console.log(res.data);
            Toast.fail(res.data.message);
            this.loading = false;
            this.finished = true;
            this.itemBoxArr = [];
          }
        })
        .catch((err) => {
          this.loading = false;
          this.finished = true;
          this.itemBoxArr = [];
          Toast.fail(err.data.message);
        });
    },
    // 获取 wlgl-token
    queryCode(code, state) {
      this.loading = true;
      this.itemBoxArr = [];
      this.params.pageNo = 0;
      this.finished = false;
      getCode({
        code: code,
        state: state,
      })
        .then((res) => {
          this.loading = false;
          if (res.data.code === 200) {
            localStorage.setItem("wlgl-token", res.data.data);
						localStorage.setItem("wlgl-openId", res.data.openId)
            this.onLoad();
          } else {
            this.errmsg = res.data.code;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import url("./zombieSource.css");
</style>
